import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { NotificationService } from '../../../core/services';

import { BillingService } from '../services/billing.service';
import { WalletTransaction, WalletTransactionKind } from '../models/transaction.model';

@Component({
  selector: 'app-billing-transactions',
  standalone: false,
  templateUrl: './billing-transactions.html',
  styleUrl: './billing-transactions.scss',
})
export class BillingTransactions implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  transactions: WalletTransaction[] = [];
  isLoading = false;

  readonly kinds: (WalletTransactionKind | 'all')[] = ['all', 'topup', 'grant', 'adjustment', 'refund'];

  /** View-only: button labels for the kind filter pills. */
  readonly kindLabels: Record<WalletTransactionKind | 'all', string> = {
    all: 'All',
    topup: 'Top-ups',
    grant: 'Grants',
    adjustment: 'Adjustments',
    refund: 'Refunds',
  };
  selectedKind: WalletTransactionKind | 'all' = 'all';

  readonly limit = 100;

  constructor(
    private billingService: BillingService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  setKind(kind: WalletTransactionKind | 'all'): void {
    if (this.selectedKind === kind) return;
    this.selectedKind = kind;
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.billingService.getTransactions({
      kind: this.selectedKind === 'all' ? undefined : this.selectedKind,
      limit: this.limit,
    })
      .pipe(
        takeUntil(this._destroy$),
        catchError(error => {
          this.notificationService.error('Failed to load transactions. Please try again later.');
          return throwError(() => error);
        }),
        tap(transactions => { this.transactions = transactions; }),
        finalize(() => { this.isLoading = false; }),
      ).subscribe();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
